import { useState } from 'react';
import ContactForm from './ContactForm';
import HeroSectionText from './HeroSectionText';
import CollapsibleContactForm from './CollapsibleContactForm';


const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-start overflow-hidden bg-black">
      {/* 🔹 Video Background */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover opacity-100"
      >
        <source src="/media/video/tiles.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Optional dark overlay */}
      <div className="absolute inset-0 bg-black/40"></div>

      {/* 🔹 Overlay Content */}
      <div className="relative z-10 w-full max-w-xl mx-auto px-4 flex flex-col items-center mt-24">
        {/* Main Text */}

        {/* Collapsible Contact Form */}
        <CollapsibleContactForm />
      </div>
    </section>
  );
};

export default HeroSection;
